<template>
  <h1>WAAWAA</h1>
</template>
<script>
export default {
  name: "Callback",
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuthState() {
      return this.$store.state.auth.state;
    }
  },
  methods: {
    methodAuthToken(token) {
      this.$store.commit("mutationAuthToken", {
        token
      });
    },
    methodAuthState(bool) {
      this.$store.commit("mutationAuthState", {
        bool
      });
    }
  },
  created() {
    if (this.$route.query.id_token) {
      this.methodAuthToken(this.$route.query.id_token);
    } else if (this.$route.query.access_token) {
      this.methodAuthToken(this.$route.query.access_token);
    }
    this.methodAuthState(true);
    this.$router.replace("/");
  }
};
</script>
